import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Text, useTheme } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';
import { getEmailsRemainingForSelection } from '../../../utils/marketingCampaignLimitsViewModel';

const EmailsRemainingIndicator = memo(({ limitsData, isLoading, selectedCount = 0 }) => {
    const theme = useTheme();

    const emailsRemaining = useMemo(() => {
        if (isLoading || !limitsData) {
            return null;
        }

        return getEmailsRemainingForSelection(limitsData, selectedCount);
    }, [isLoading, limitsData, selectedCount]);

    if (emailsRemaining === null) {
        return null;
    }

    return (
        <div className="fm-select-recipients-modal__emails-remaining">
            <Text type="subtitle1" color={theme.colors.utility.textSecondary}>
                {getLiteral('label_marketing_campaigns_emails_remaining')}:
            </Text>
            <Text type="subtitleLg" medium>
                {emailsRemaining}
            </Text>
        </div>
    );
});

EmailsRemainingIndicator.displayName = 'EmailsRemainingIndicator';

EmailsRemainingIndicator.propTypes = {
    limitsData: PropTypes.shape({
        dailyLimit: PropTypes.number,
        monthlyLimit: PropTypes.number,
        dailyUsed: PropTypes.number,
        monthlyUsed: PropTypes.number,
    }),
    isLoading: PropTypes.bool,
    selectedCount: PropTypes.number,
};

export default EmailsRemainingIndicator;
